import { useEffect, useState } from 'react';
import api from '../api';
import { getToken } from '../utils/token';

export default function ViewUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = getToken();
        const res = await api.get('/users', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(res.data);
      } catch (err) {
        console.error('Error al obtener usuarios:', err);
        alert('Error al obtener usuarios');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) return <p>Cargando usuarios...</p>;

  return (
    <div>
      <h2>👥 Lista de Usuarios Registrados</h2>
      <ul>
        {users.map((user) => (
          <li key={user.id}>
            <strong>ID:</strong> {user.id} |{' '}
            <strong>Nombre:</strong> {user.name} |{' '}
            <strong>Email:</strong> {user.email}
          </li>
        ))}
      </ul>
    </div>
  );
}
